<template>
  <b-calendar />
</template>

<script>
import BCalendar from '@/components/base/DateTime/Date/Calendar/b-calendar.vue'
export default {
  name: 'BCalendarDemo',
  components: { BCalendar, },
}
</script>
